<template>
<div id="main">
<div id="content">
<div id="boxinfo">
  <el-table
    :data="scanBoxList"
    :init="init"
    style="width: 100%"
    height="350">
    <el-table-column
      fixed
      prop="fbaBoxNo"
      label="FBA Box#"
      width="200">
    </el-table-column>
    <el-table-column
      prop="citiBoxNo"
      label="CITITRANS Box#"
      width="200">
    </el-table-column>
    <el-table-column
      prop="length"
      label="Length(CM)"
      width="120">
    </el-table-column>
    <el-table-column
      prop="width"
      label="Width(CM)"
      width="120">
    </el-table-column>
    <el-table-column
      prop="height"
      label="Height(CM)"
      width="120">
    </el-table-column>
    <el-table-column
      prop="weight"
      label="Weight(KG)"
      width="120">
    </el-table-column>
     <el-table-column
      prop="volume"
      label="Volume(CBM)"
      width="120.">
    </el-table-column>
     <el-table-column
      prop="imgUrl"
      label="Picture"
      width="120">
      <template slot-scope="scope">
        <a :href="scope.row.imgUrl" target="_blank" class="buttonText" v-if="scope.row.imgUrl!=='undefined' && scope.row.imgUrl!=null && scope.row.imgUrl!==''">Download</a>
        <span v-if="scope.row.imgUrl=='undefined' ||scope.row.imgUrl==null || scope.row.imgUrl ===''">Waiting</span>
      </template>
    </el-table-column>
  </el-table>
  </div>
  <div v-if="confirmDivVisible" id="descContent">
   <br/>
    <br/>
  <el-row>
  <el-col :span="24"><div class="grid-content bg-purple-dark">请核对以上入仓数据，如果有异议，请点击拦截按钮，以继续拦截货物发出并线下联系客服，否则货物将会滞留24小时后发出。如果有异议，请点击拦截按钮，以继续拦截货物发出。如24小时内未操作，默认表示同意我方的测量数据。</div></el-col>
    <el-col :span="24"><div class="grid-content bg-purple-dark">Please check the above warehousing data, if there is no objection, please click the agree button to release the shipment, otherwise the goods will be delayed for 24 hours and then sent out if no response. If you have any objection, please click the hold button and contact our customer service offline for furture notice. If you do not response within 24 hours, you agree to our measurement data by default. </div></el-col>
    <el-col :span="8">
     <br />
    </el-col>
     <el-col :span="4">
       <el-button type="success" id="agreeBtn" @click="sellerWarehouseDataConfirm(1)">Agree(同意)</el-button>
     </el-col>
      <el-col :span="4">
       <el-button type="danger" id="interceptBtn" @click="sellerWarehouseDataConfirm(2)">Hold(拦截)</el-button>
     </el-col>
</el-row>
  </div>
  </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        scanBoxList: [],
        confirmDivVisible: false,
      }
    },
    watch: {},
    state: {
      
    },
    computed:{
      init() {
        this.listScanBoxInfo();
        this.checkSellerConfirmStatus();
      }
    },
    methods: {
    listScanBoxInfo() {
         let fbaNo =  this.$route.query.fbaNo;
         let token =  this.$route.query.token;
         let params = {
          fbaNo: fbaNo, // FBA号
          token: token  // Token
        };
        this.axios.post(`/send/openapi/listScanBoxInfo`, params).then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            // this.$message({ message: "成功", type: "success" });
            this.scanBoxList = res.data.datas;
          } else {
            this.$message(res.data.message);
          }
        });
      },
      checkSellerConfirmStatus() {
         let fbaNo =  this.$route.query.fbaNo;
         let token =  this.$route.query.token;
         let params = {
          fbaNo: fbaNo, // FBA号
          token: token  // Token
        };
        this.axios.post(`/send/openapi/checkSellerConfirmStatus`, params).then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            // this.$message({ message: "成功", type: "success" });
            this.confirmDivVisible = !res.data.data;
          } else {
            this.$message(res.data.message);
          }
        });
      },
      sellerWarehouseDataConfirm(sendSellerStatus) {
       let fbaNo =  this.$route.query.fbaNo;
         let token =  this.$route.query.token;
         let params = {
          fbaNo: fbaNo, // FBA号
          token: token,  // Token
          sendSellerStatus: sendSellerStatus
        };
        let title = '';
        if(sendSellerStatus === 1) {
           title = 'Are you sure you want to agree to the above data?';
        } else if(sendSellerStatus === 2) {
           title = 'Are you sure you want to hold the shipment?';
        }
        this.$confirm(title, 'Tip', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
        this.axios.post(`/send/openapi/sellerWarehouseDataConfirm`, params).then((res) => {
          console.log(res);
          if (res.data.code == "200") {

            let isSuccess = res.data.data;
            if(isSuccess) {
                 this.$message({ message: "成功", type: "success" });
                 this.confirmDivVisible=false;
            }
          } else {
            this.$message(res.data.message);
          }
        });
         }).catch(() => {});
      }
    }
  }
</script>

<style>
   *{
      margin: 0;
      padding: 0; 
    }
   #main {
    width:100%;
   }
   #content {
    width:100%;
   }
   #boxinfo {
     width: 1200px;
      background-color: white;
      /* 水平垂直居中 */
      margin: 100px auto
   }
   #descContent {
     width: 1200px;
      background-color: white;
      /* 水平垂直居中 */
      margin: 50px auto
   }
   #agreeBtn {
     width: 160px;
   }
   #interceptBtn {
     width: 160px;
   }
</style>


// WEBPACK FOOTER //
// src/components/SEND/SellerWarehouseDataConfirm.vue